import { render, staticRenderFns } from "./remark-edit.vue?vue&type=template&id=55814f48"
import script from "./remark-edit.vue?vue&type=script&lang=js"
export * from "./remark-edit.vue?vue&type=script&lang=js"
import style0 from "./remark-edit.vue?vue&type=style&index=0&id=55814f48&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports